import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { lbToKG, kgToLb } from "Helpers/util";
import React, { useState, useEffect, memo } from "react";
import WeightComponent from "Root/quiz/elements/InputWeightElement/weight";
const GoalWeight = (props) => {
    const getDefaultValues = () => {
        if (props.prevAnswer) {
            const lb = props.prevAnswer;
            const kg = lbToKG(lb);
            return { weight: lb, weightKg: kg.toString() };
        }
        return { weight: "", weightKg: "" };
    };
    const [answer, setAnswer] = useState(getDefaultValues());
    const handleWeightInput = (e) => {
        const val = `${parseInt(e)}`;
        setAnswer((prevState) => ({
            ...prevState,
            weight: val,
            weightKg: lbToKG(val).toString(),
        }));
    };
    const handleWeightKgInput = (e) => {
        const val = `${parseInt(e)}`;
        setAnswer((prevState) => ({
            ...prevState,
            weightKg: val,
            weight: kgToLb(val).toString(),
        }));
    };
    useEffect(() => {
        if (!Number.isNaN(answer.weight) && !Number.isNaN(answer.weightKg)) {
            props.setValue([answer.weight]);
        }
    }, [answer]);
    return (_jsx(_Fragment, { children: _jsx(WeightComponent, { setValue: props.metrics ? handleWeightKgInput : handleWeightInput, value: props.metrics ? answer.weightKg : answer.weight, metrics: props.metrics, setMetrics: props.setMetrics, hideMetrics: props.hideMetrics }) }));
};
export default memo(GoalWeight);
